import SearchBatches from "./SearchBatches";

export default SearchBatches;